import { render, staticRenderFns } from "./bbs.vue?vue&type=template&id=1fe64054&scoped=true"
import script from "./bbs.vue?vue&type=script&lang=js"
export * from "./bbs.vue?vue&type=script&lang=js"
import style0 from "./bbs.vue?vue&type=style&index=0&id=1fe64054&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe64054",
  null
  
)

export default component.exports